export default "/images/crossIcon.svg?9495a7e698cb0d48704af8caa0b51e5a";